<template>
  <div class="signature">
    <div class="debt-signature" :style="signatureStyle">
      <div class="top">手写签名</div>
      <canvas ref="signcanvas" class="canvas"></canvas>
      <div class="bottom">
        <div class="left">
          <div class="rewrite" @click="clearCanvas">重写</div>
          <div
            class="choice-color"
            v-for="(color, i) in borderColor"
            :key="i"
            :style="{ borderColor: color }"
            :class="{ active: activeIndex === i }"
            @click="choiceColor(color, i)"
          >
            <span :style="{ background: color }"></span>
          </div>
        </div>
        <div class="right">
          <van-button class="btn-cancel" @click="goBack">取消</van-button>
          <van-button class="btn-confirm" @click="confirm">确认</van-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Bus from "../../../providers/eventBus";
export default {
  data() {
    return {
      canvas: {},
      ctx: {},
      isConfirm: false,
      color: "",
      signatureStyle: {
        width: "100%",
        height: "100%",
        transformOrigin: "left top",
        transform: "",
      },
      canvasStyle: {
        width: "",
        height: "",
      },
      activeIndex: 0,
      // 黑 红 蓝
      borderColor: ["#000", "#ff0000", "#0C77FA"],
    };
  },
  created() {},
  mounted() {
    // 横屏效果 设置宽等于高，高等于宽
    this.signatureStyle.width = document.body.clientHeight + "px"; //375
    this.signatureStyle.height = document.body.clientWidth + "px"; //667
    // 因为设置了transformOrigin: 'left top'，所以直接向右移动屏幕宽度 + 旋转90° 刚好形成横屏效果
    this.signatureStyle.transform = `translate(${document.body.clientWidth}px) rotate(90deg)`;

    this.canvasStyle = {
      // 30 左右边距30
      width: document.body.clientHeight - 30 + "px",
      // 134 = 顶部50  + 顶部到中间的间距12  +  底部70
      height: document.body.clientWidth - 134 + "px",
    };
    this.initCanvas();
  },
  beforeDestroy() {
    if (!this.isConfirm) return;

    const data = {
      img_file: this.img_file,
      img_name: this.img_name,
    };
    Bus.$emit("busSignature", data);
  },
  methods: {
    initCanvas() {
      const canvas = this.$refs.signcanvas;
      this.canvas = canvas;

      const ctx = this.canvas.getContext("2d");
      this.ctx = ctx;

      const height = this.canvasStyle.height.replace("px", "");
      const width = this.canvasStyle.width.replace("px", "");

      canvas.height = height;
      canvas.width = width;

      // 根据设备像素比优化canvas绘图
      const devicePixelRatio = window.devicePixelRatio;
      if (devicePixelRatio) {
        canvas.style.width = `${width}px`;
        canvas.style.height = `${height}px`;
        canvas.height = height * devicePixelRatio;
        canvas.width = width * devicePixelRatio;
        ctx.scale(devicePixelRatio, devicePixelRatio);
      } else {
        canvas.width = width;
        canvas.height = height;
      }

      // 线宽
      ctx.lineWidth = 6;
      // 线条颜色
      ctx.strokeStyle = this.color;
      // 线的两端样式 round圆角
      ctx.lineCap = "round";
      // 线的交叉处样式 round圆角
      ctx.lineJoin = "round";

      const { left, top } = this.canvas.getBoundingClientRect();

      const touchstartFunc = (e) => {
        e.preventDefault();
        // const x = e.touches[0].clientX - left
        // const y = e.touches[0].clientY - top
        // 由于页面旋转过，所以需要将 clientX 和 canvas坐标系 一一对应，clientY同理
        const x = e.touches[0].clientY - left;
        const y = document.body.clientWidth - e.touches[0].clientX - top;
        this.ctx.beginPath();
        this.ctx.moveTo(x, y);
      };
      const touchmoveFunc = (e) => {
        e.preventDefault();
        const x = e.touches[0].clientY - left;
        const y = document.body.clientWidth - e.touches[0].clientX - top;
        this.ctx.lineTo(x, y);
        this.ctx.stroke();
      };
      this.canvas.addEventListener("touchstart", touchstartFunc, false);
      this.canvas.addEventListener("touchmove", touchmoveFunc, false);
    },
    clearCanvas() {
      this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
    },
    choiceColor(color, i) {
      this.activeIndex = i;
      this.color = color;
      this.ctx.strokeStyle = color;
      this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
    },
    goBack() {
      this.$router.go(-1);
    },
    dataURLtoFile(dataURL, fileName, fileType) {
      var arr = dataURL.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], fileName, { type: fileType || "image/png" });
    },
    async confirm() {
      try {
        let img = this.canvas.toDataURL("image/png");

        const token = await this.$api.post(
          "contract/member/file/update/token",
          { type: "seal" }
        );
        const key = `${token.file_path}.png`;

        const img_file = this.dataURLtoFile(img, key, "image/png");
        let formData = new FormData();
        formData.append("token", token.token);
        formData.append("file", img_file);
        formData.append("key", key);

        const res = await axios.post("https://up-z0.qiniup.com", formData);
        // TODO 这里不能用push，要用go -1 ，参数由event bus传过去
        this.isConfirm = true;
        this.img_file = img;
        this.img_name = res.key;
        this.$router.go(-1);
      } catch (error) {}
    },
  },
};
</script>

<style lang="less">
// .signature {
//   height: 100%;
//   overflow-x: auto;
.debt-signature {
  // border: 2px solid red;
  background-color: #f5f6ff;
  // transform: scale(0.5);
  .top {
    background-color: #ffffff;
    height: 50px;
    line-height: 50px;
    font-size: 18px;
    text-align: center;
  }
  .canvas {
    margin: 12px 15px 0;
    background-color: #ffffff;
  }
  .bottom {
    margin: 0 15px;
    padding: 15px 0;
    height: 70px;
    box-sizing: border-box;
    line-height: 70px;
    display: flex;
    justify-content: space-between;
    .left {
      display: flex;
      align-items: center;
      height: 100%;
      margin-left: 40px; // 解决重写按钮布局问题
      .rewrite {
        height: 100%;
        color: #f9591b;
        display: flex;
        align-items: center;
        font-size: 16px;
        width: 52px;
        border-right: 1px solid #000;
      }
      .choice-color {
        width: 22px;
        height: 22px;
        line-height: 22px;
        box-sizing: border-box;
        border-radius: 50%;
        margin-left: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        span {
          display: inline-block;
          width: 16px;
          height: 16px;
          border-radius: 50%;
        }
        &.active {
          border-width: 1px;
          border-style: solid;
        }
      }
    }
    .right {
      margin-right: 50px;
      display: flex;
      align-items: center;
      .btn-cancel {
        width: 80px;
        background-color: #ffffff;
        border-radius: 5px;
        font-size: 16px;
      }
      .btn-confirm {
        width: 80px;
        margin-left: 20px;
        background-color: #5853e9;
        color: #ffffff;
        border-radius: 5px;
        font-size: 16px;
      }
    }
  }
}
// }
</style>
